import React from 'react';
import Card from '../../Card';
import Grid from '../../Grid';
import { Typography } from '../../Typography';
var Section = function (_a) {
    var title = _a.title, children = _a.children;
    return (React.createElement(Grid, { item: true, xs: 12, sm: 10, md: 6 },
        React.createElement(Card, null,
            React.createElement(Grid, { container: true, spacing: 4, style: { padding: '30px' } },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Typography.H3, null, title)),
                React.createElement(Grid, { item: true, xs: 12 }, children)))));
};
export default Section;
//# sourceMappingURL=Section.js.map